import { render, staticRenderFns } from "./BPDropdown.vue?vue&type=template&id=32932a29&scoped=true&"
import script from "./BPDropdown.vue?vue&type=script&lang=js&"
export * from "./BPDropdown.vue?vue&type=script&lang=js&"
import style0 from "./BPDropdown.vue?vue&type=style&index=0&id=32932a29&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32932a29",
  null
  
)

component.options.__file = "BPDropdown.vue"
export default component.exports